import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import './index.css';
import App from './App';
import msalConfig from './Auth/authConfig';
import reportWebVitals from './reportWebVitals';
import './index.css'
import { ActiveButtonProvider } from './Contexts/ActiveButtonContext';

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ActiveButtonProvider>
        <App />
      </ActiveButtonProvider>
    </MsalProvider>
  </React.StrictMode>
);

reportWebVitals();
